import * as React from "react";

export interface LabelProps {
  type: string;
  name: string;
  text: string;
  popupHint: JSX.Element | null;
  className: string;
  maxLength?: number;
  counterValue?: number;
  counterUnit?: string;
  textAreaCounter?: boolean;
}

export const Label = (props: LabelProps) => {
  if (props.type === "radio") {
    return (
      <p className="radiogroup__label" id={`radiogroup-label-${props.name}`}>
        {props.text}
        {props.popupHint}
      </p>
    );
  }

  if (props.type === "textArea") {
    const counterUnitString = props.counterUnit ? ` ${props.counterUnit}` : "";

    return (
      <label
        className={`input__label${props.className} input__label--with-counter`}
        htmlFor={props.name}
        aria-live="polite"
        aria-atomic="true"
      >
        <span className="input__label-text">{props.text}</span>
        {props.popupHint}
        {props.textAreaCounter && props.maxLength && (
          <span className="input__label-count-block">{`(${props.counterValue ?? 0} / ${
            props.maxLength
          }${counterUnitString})`}</span>
        )}
      </label>
    );
  }

  return (
    <label className={`input__label${props.className}`} htmlFor={props.name}>
      {props.text}
      {props.popupHint}
    </label>
  );
};
